import { QueryClient } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';
import styled from 'styled-components';

import LandingPageHome from '../components/LandingPageHome';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import useRoutePrefetch from '../hooks/useRoutePrefetch';
import {
  detectAndBestEffortSetLanguage,
  getLocaleRedirectIfNeeded,
} from '../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../utils/react-query-utils';

const Home: NextPageWithLayout = () => {
  useRoutePrefetch('/[tenantId]/lessons');
  useRoutePrefetch('/[tenantId]/workspace/[workspaceId]');
  const { t } = useTranslate();

  return (
    <Container>
      <LandingPageLayout
        hideBlobs={true}
        disableHeadline={true}
        title={t('meta.landing.title.v2', 'Curipod - Writing Practice Students Love')}
        subTitle={t(
          'meta.landing.description.v6',
          `Teacher led lessons aligned to your district's curriculum. Students read, write and discuss. Not alone on the screen. Together.`,
        )}
      >
        <LandingPageHome />
      </LandingPageLayout>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
`;

export const getServerSideProps: GetServerSideProps = async context => {
  const localeRedirect = getLocaleRedirectIfNeeded(context, '/learn');
  if (localeRedirect) return localeRedirect;

  const queryClient = new QueryClient();

  return {
    props: {
      dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

Home.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
export default Home;
